import {UserPermissionEnum} from "../../../../utils/types/user";

// TODO(reports/single-source-of-truth): import report list struct from page

export const GeneralTypes = [
  {
    label: "Admissions Overview",
    value: UserPermissionEnum.ADMISSION_IN_TOTAL,
  },
  {
    label: "Completion Time",
    value: UserPermissionEnum.COMPLETION_RATE_ONCE_ADMISSION_IS_SIGNED,
  },
  {
    label: "Photo/Payer ID",
    value: UserPermissionEnum.PHOTOS,
  },
  {
    label: "Arbitration",
    value: UserPermissionEnum.ARBITRATION_AGREEMENT,
  },
];

export const CheckboxesTypes = [
  {
    label: "Admission Checklist Items",
    value: UserPermissionEnum.CHECKLIST_ITEMS,
  },
];

export const DashboardsTypes = [
  {
    label: "Quicksight Dashboards",
    value: UserPermissionEnum.QUICKSIGHT_DASHBOARDS,
  },
];

export const OtherTypes = [
  {
    label: "Approved Admission in total",
    value: UserPermissionEnum.APPROVED_ARCHIVED_ADMISSIONS,
  },
  {
    label: "Admissions completed with represent",
    value:
      UserPermissionEnum.PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE,
  },
  {
    label: "Avg. time spent to close admission",
    value: UserPermissionEnum.AVG_TIME_SPENT_TO_CLOSE_ADMISSION,
  },
  {
    label: "Total number of Residents over time",
    value: UserPermissionEnum.ANALYTICS_ADMISSION_IN_TOTAL,
  },
  {
    label: "Residents with Medicaid",
    value: UserPermissionEnum.RESIDENTS_WITH_MANAGED_MEDICAID,
  },
  {
    label: "Re-admission rate",
    value: UserPermissionEnum.READMISSION_RATE,
  },
  {
    label: "Patients with Medicare",
    value: UserPermissionEnum.PATIENTS_WITH_MEDICAL_SUPPLEMENT,
  },
  {
    label: "Admission Completion Rate per Facility Staff",
    value: UserPermissionEnum.ADMISSION_COMPLETION_RATE,
  },
  {
    label: "Admissions completion on time",
    value: UserPermissionEnum.COMPLETION_TIME,
  },
  {
    label: "Most frequently flagged slides",
    value: UserPermissionEnum.MOST_FREQUENTLY_FLAGGED_SLIDES,
  },
  {
    label: "Payer Source Age 65-75 ",
    value: UserPermissionEnum.PAYER_SOURCE_AGE_65_75,
  },
  {
    label: "Payer Source Age 75-85 ",
    value: UserPermissionEnum.PAYER_SOURCE_AGE_75_85,
  },
  {
    label: "Payer Source Age 85+ ",
    value: UserPermissionEnum.PAYER_SOURCE_AGE_85,
  },
  {
    label: "Arbitration agreement completed",
    value: UserPermissionEnum.ARBITRATION_AGREEMENT_COMPLETED,
  },
  {
    label: "Patients without Medicare",
    value: UserPermissionEnum.PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT,
  },
  {
    label: "Avg. time spent of each stage of admission",
    value: UserPermissionEnum.AVG_TIME_SPENT_OF_EACH_STAGE_OF_ADMISSION,
  },
  {
    label: "Age of help flags",
    value: UserPermissionEnum.AGE_OF_HELP_FLAGS,
  },
  {
    label: "Slide Interactions",
    value: UserPermissionEnum.SLIDE_INTERACTIONS,
  },
  {
    label: "Staff",
    value: UserPermissionEnum.STAFF_ADMISSIONS,
  },
  {
    label: "Income & Personal Resource",
    value: UserPermissionEnum.INCOMES_AND_PERSONAL_RESOURCE,
  },
  {
    label: "Trust Fund",
    value: UserPermissionEnum.TRUST_FUND_POLICY,
  },
  {
    label: "Laundry Consent",
    value: UserPermissionEnum.LAUNDRY_CONSENT,
  },
  {
    label: "Pneumococcal",
    value: UserPermissionEnum.PNEUMOCOCCAL_VACCINES,
  },
  {
    label: "Influenza",
    value: UserPermissionEnum.INFLUENZA_VACCINES,
  },
  {
    label: "Surrogate Decision Making",
    value: UserPermissionEnum.SURROGATE_DECISION_MAKING,
  },
  {
    label: "Surrogate Decision Making Requests",
    value:
      UserPermissionEnum.SURROGATE_DECISION_RESIDENTS_REQUESTING_FOR_MORE_INFORMATION,
  },
  {
    label: "Existing Advanced Directive Provided",
    value: UserPermissionEnum.EXISTING_ADVANCED_DIRECTIVE_PROVIDED,
  },
  {
    label: "Residents requesting for help with Advanced Directive",
    value:
      UserPermissionEnum.RESIDENTS_REQUESTING_FOR_HELP_WITH_CREATING_ADVACED_DIRECTIVE,
  },
  {
    label: "Funeral",
    value: UserPermissionEnum.FUNERAL,
  },
  {
    label: "Waiver of Medicare Benefits",
    value: UserPermissionEnum.MEDICARE_WAIVER,
  },
  {
    label: "Medicaid Request",
    value: UserPermissionEnum.RESIDENTS_REQUESTING_APPLICATION_FROM_MEDICAID,
  },
  {
    label: "SNFABN Estimated Cost",
    value: UserPermissionEnum.ESTIMATED_COST_TRACKED_BY_ROLE_AND_DATE,
  },
  {
    label: "Facility Settings",
    value: UserPermissionEnum.FACILITY_CHANGES,
  },
];
